import React, { Component } from "react"
import TableNotasFiscaisTrash from "./TableNotasFiscaisTrash"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
import Moment from "moment"

export default class NotasFiscaisTrash extends Component {
  constructor() {
    super()
    this.getNotas = this.getNotas.bind(this)
    this.didRestore = this.didRestore.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { notas: [], initialNotas: [], showTable: false }
  }
  componentWillMount() {
    this.getNotas()
  }
  getNotas() {
    var contratoID = this.props.match.params.id
    ApiHelper.getNotasTrash(contratoID, (notas, error) => {
      if (notas) {
        this.setState({ notas: notas, initialNotas: notas, showTable: true })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didRestore() {
    this.getNotas()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialNotas.filter(nota => {
      return (
        nota.numero.toLowerCase().search(searchText) !== -1 ||
        Moment(nota.data)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        nota.contrato.objeto.toLowerCase().search(searchText) !== -1
      )
    })
    this.setState({
      notas: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Contratos">
        {this.state.showTable ? (
          <TableNotasFiscaisTrash
            filter={this.filter}
            onRestore={this.didRestore}
            sizeClass=""
            title="Notas fiscais deletadas"
            subtitle={
              "Listagem de todas as notas fiscais deletadas do contrato Nº: " +
              (this.state.initialNotas[0]
                ? this.state.initialNotas[0].contrato.num_contrato
                : "")
            }
            backgroundColor="as-blue"
            rows={this.state.notas}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/baixas/NotasFiscaisTrash.js